import { Toast } from 'vant'
import NavBar from '@/components/Nav.vue';

export default {
    name: 'OrganizationPage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            subscribes: [],
            organizations: []
        }
    },
    created() {
        this.getOrganizationList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getOrganizationList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('organization').then(result => {
                    console.log(result)
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.subscribes = this.subscribes.concat(result.data.subscribes);
                    this.organizations = this.organizations.concat(result.data.organizations);
                })
            }
        },
        toggleSubscribe(id) {
            this.$http.put('organization/' + id + '/subscribe').then(() => {
                if (this.subscribes.indexOf(id) > -1) {
                    this.subscribes.splice(this.subscribes.indexOf(id), 1);
                } else {
                    this.subscribes.push(id)
                }
                Toast('操作成功');
            })
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getOrganizationList();
            }
        }
    }
}